import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  alpha,
  useTheme,
  Breadcrumbs,
  Paper,
} from "@mui/material";
import { Add, MapsUgc, ChevronRight } from "@mui/icons-material";
import CommunicationTable from "./CommunicationTable";
import CommunicationFormDialog from "./Dialog/CommunicationFormDialog";
import { useParams, Link } from "react-router-dom";
import useClientDetails from "../../../../../hooks/useClientDetails";

const Communication = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { clientID } = useParams();
  const { fullName } = useClientDetails(clientID);

  return (
    <Box sx={{ p: 3, bgcolor: '#f8fafc', minHeight: '100vh' }}>
      
      {/* Header Section */}
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Breadcrumbs 
            separator={<ChevronRight sx={{ fontSize: 14 }} />} 
            sx={{ mb: 1, '& .MuiTypography-root': { fontSize: '0.75rem', fontWeight: 600, color: 'text.disabled' } }}
          >
            <Typography component={Link} to="/clients" sx={{ textDecoration: 'none', color: 'inherit', '&:hover': { color: 'primary.main' } }}>
              Service User
            </Typography>
            <Typography color="text.primary">{fullName?.toUpperCase()}</Typography>
          </Breadcrumbs>
          
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box sx={{ 
              bgcolor: theme.palette.primary.main, 
              color: '#fff', 
              p: 1, 
              borderRadius: 2, 
              display: 'flex',
              boxShadow: `0 8px 16px ${alpha(theme.palette.primary.main, 0.2)}`
            }}>
              <MapsUgc sx={{ fontSize: 24 }} />
            </Box>
            <Box>
              <Typography variant="h5" fontWeight={900} sx={{ color: '#1e293b', lineHeight: 1 }}>
                Communication Notes
              </Typography>
              <Typography variant="caption" fontWeight={700} color="text.disabled" sx={{ letterSpacing: '0.5px' }}>
                CHRONOLOGICAL RECORD OF INTERACTIONS
              </Typography>
            </Box>
          </Stack>
        </Box>

        {/* Action Button */}
        <Button
          variant="contained"
          startIcon={<Add sx={{ fontWeight: 900 }} />}
          sx={{
            bgcolor: theme.palette.primary.main,
            textTransform: "none",
            px: 3,
            py: 1.2,
            fontWeight: 800,
            borderRadius: 3,
            boxShadow: `0 8px 20px ${alpha(theme.palette.primary.main, 0.25)}`,
            '&:hover': {
              bgcolor: theme.palette.primary.dark,
              transform: 'translateY(-2px)',
              boxShadow: `0 10px 25px ${alpha(theme.palette.primary.main, 0.35)}`,
            },
            transition: 'all 0.3s'
          }}
          onClick={() => setOpen(true)}
        >
          Add New Note
        </Button>
      </Box>

      {/* Dialog */}
      <CommunicationFormDialog open={open} onClose={() => setOpen(false)} />

      {/* Table Section */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
          boxShadow: '0 4px 12px rgba(0,0,0,0.02)',
          overflow: 'hidden',
          bgcolor: '#fff'
        }}
      >
        <CommunicationTable />
      </Paper>
    </Box>
  );
};

export default Communication;